import type { TrackCompareSelect } from '@/app/lcv/components/sections/compare/types';
import { isDataLayerAvailable } from '@/tag-manager';
import { CUSTOM_EVENT_DYNAMIC_EVENT } from '@/tag-manager/constants';

export const MAIN = 'compare';

export const PRODUCT_COMPARE_DATA_TEST = {
  image: `${MAIN}-image`,
  imageSlide: `${MAIN}-image-slide`,
  imageEmpty: `${MAIN}-image-empty`,
  headline: `${MAIN}-headline`,
  color: `${MAIN}-color`,
  colorSelect: `${MAIN}-color-select`,
  colorDetail: `${MAIN}-color-detail`,
  priceCta: `${MAIN}-price-cta`,
  registerCta: `${MAIN}-register-cta`,
  productCta: `${MAIN}-product-cta`,
  summary: `${MAIN}-summary`,
  toggle: `${MAIN}-toggle`,
  remark: `${MAIN}-remark`,
} as const;

export const PRODUCT_COMPARE_DATA_GA = {
  main: MAIN,
  select: `${MAIN}-select`,
} as const;

export function trackCompareSelect({
  modelsGroup,
  modelKeys,
  modelColors,
}: TrackCompareSelect) {
  if (modelKeys.length === 0) return;

  const contentIDs: string[] = [];
  const contentTypes: string[] = [];
  const drivetrains: string[] = [];
  const prices: string[] = [];
  const colors: string[] = [];

  modelKeys.forEach((key, index) => {
    const model = modelsGroup[key];
    if (model) {
      const modelColor = modelColors[index];
      contentIDs.push(model.documentId);
      contentTypes.push(model.category?.nameTh ?? '');
      drivetrains.push(model.name);
      if (modelColor) {
        prices.push(`${(model.price || 0) + (modelColor.price || 0)}`);
        colors.push(modelColor.color?.nameTh ?? '');
      } else {
        prices.push('');
        colors.push('');
      }
    } else {
      contentIDs.push('');
      contentTypes.push('');
      drivetrains.push('');
      prices.push('');
      colors.push('');
    }
  });

  if (!isDataLayerAvailable()) return;

  window.dataLayer.push({
    event: CUSTOM_EVENT_DYNAMIC_EVENT,
    event_name: PRODUCT_COMPARE_DATA_GA.select,
    content_ids: contentIDs.join(','),
    content_type: contentTypes.join(','),
    drivetrain: drivetrains.join(','),
    price: prices.join(','),
    color: colors.join(','),
  });
}
